<template>
  <div class="page page-membership-cards">
    <!-- 头部导航 -->
    <header class="header">
      <div class="nav-left">
        <div class="back-btn el-icon-arrow-left" @click="goBack"></div>
      </div>
      <div class="nav-center">
        <h1 class="page-title">我的会员卡</h1>
      </div>
    </header>

    <!-- 会员卡列表 -->
    <div class="cards-container">
      <div class="cards-grid">
        <div
          v-for="card in membershipCards"
          :key="card.id"
          class="membership-card"
          :class="[card.cardType, card.status]"
          @click="selectCard(card)"
        >
          <!-- 场次信息 -->
          <div class="sessions-info">
            <div class="sessions-count">{{ card.remainingSessions }}场</div>
          </div>

          <!-- 卡片背景图片 -->
          <div class="card-background">
            <img :src="card.cardUrl" alt="早鹰会员卡" class="card-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
export default {
  name: "MembershipCards",
  data() {
    return {
      membershipCards: [
        {
          id: 1,
          cardUrl: require("@/assets/membershipCard.jpg"),
          remainingSessions: 0
        }
      ]
    };
  },
  async mounted() {
    await this.getUserInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    async getUserInfo() {
      try {
        let data={
          openid: localStorage.getItem("openid"),
          clientsessionkey: localStorage.getItem("clientSessionKey")
        }
        await api.GetUserInfo(data).then(response => {
          this.membershipCards[0].remainingSessions = Number(response);
          localStorage.setItem("movieShowtimes", Number(response));
        });
      } catch (error) {
        console.error("获取个人剩余场次失败:", error);
        this.$message && this.$message.error("获取个人剩余场次失败");
      }
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: linear-gradient(
    135deg,
    rgba(195, 77, 52, 0.28) 0%,
    rgba(248, 248, 248, 0.08) 100%
  );
  padding: 0;
}

/* 头部导航 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid #e0e0e0;
}

.nav-left,
.nav-right {
  width: 40px;
  z-index: 99;
}

.nav-center {
  flex: 1;
  text-align: center;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 0 -40px;
}

/* 头部导航三端适配 */
@media (min-width: 768px) {
  .header {
    padding: 16px 24px;
  }

  .page-title {
    font-size: 20px;
    margin: 0 0 0 -40px;
  }

  .back-btn,
  .share-btn {
    font-size: 20px;
    padding: 10px;
  }
}

@media (min-width: 1024px) {
  .header {
    padding: 20px 32px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .page-title {
    font-size: 22px;
    margin: 0 0 0 -40px;
  }

  .back-btn,
  .share-btn {
    font-size: 22px;
    padding: 12px;
  }
}

.back-btn,
.share-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #333;
  cursor: pointer;
  padding: 8px;
}

/* 卡片容器 */
.cards-container {
  padding: 20px 16px;
}

.cards-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

/* 会员卡样式 */
.membership-card {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 12px;
}

/* ===== 三端适配 ===== */

/* 平板端适配 (768px - 1023px) */
@media (min-width: 768px) {
  .cards-container {
    padding: 24px 24px;
  }

  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  .membership-card {
    border-radius: 18px;
  }

  .sessions-info {
    top: 6%;
    right: 3%;
    padding: 10px 14px;
  }

  .sessions-count {
    font-size: 18px;
  }
}

/* 桌面端适配 (1024px+) */
@media (min-width: 1024px) {
  .cards-container {
    padding: 32px 32px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .cards-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 28px;
  }

  .membership-card {
    border-radius: 20px;
  }

  .membership-card:hover {
    transform: translateY(-6px);
  }

  .sessions-info {
    top: 6%;
    right: 3%;
    padding: 12px 16px;
  }

  .sessions-count {
    font-size: 20px;
  }
}

.membership-card:hover {
  transform: translateY(-4px);
}

.membership-card.expired {
  opacity: 0.6;
  filter: grayscale(0.3);
}

@keyframes gentle-float {
  0%,
  100% {
    transform: translateY(0px) scale(1);
    opacity: 0.8;
  }
  50% {
    transform: translateY(-8px) scale(1.05);
    opacity: 0.6;
  }
}

/* 场次信息 */
.sessions-info {
  position: absolute;
  top: 6%;
  right: 3%;
  z-index: 3;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 8px 12px;
  border-radius: 20px;
  text-align: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.sessions-count {
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  letter-spacing: 2px;
}

/* 卡片背景 */
.card-background {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

/* 平板端卡片背景优化 */
@media (min-width: 768px) {
  .card-background {
    border-radius: 18px;
  }
}

/* 桌面端卡片背景优化 */
@media (min-width: 1024px) {
  .card-background {
    border-radius: 20px;
  }
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

/* 平板端图片优化 */
@media (min-width: 768px) {
  .card-image {
    object-fit: contain;
  }
}

/* 桌面端图片优化 */
@media (min-width: 1024px) {
  .card-image {
    object-fit: contain;
  }

  .card-image:hover {
    transform: scale(1.02);
  }
}
</style>
